import $ from 'jquery';
import rimg from 'rimg-shopify';
import CurrencyConverter from 'shopify-currency-converter';
import AsyncView from 'shopify-asyncview';
import 'intersection-observer';

import ProductGridItem from '../components/ProductGridItem';
import RecentlyViewed from '../components/RecentlyViewed';
import Modal from '../components/Modal';

export default class StaticCollection {
  constructor(section) {
    this.section    = section;
    this.$el        = $(section.el);
    this.context    = section.data.context;
    this.ajaxEvents = [];
    this.events = [];
    this.$focusItem = null;
    this.processing = false;
    this.queryString = {};

    this.filtersContent     = '[data-productgrid-filters-content]';
    this.sortContent        = '[data-productgrid-sort-content]';
    this.$sortTrigger       = $('[data-productgrid-trigger-sort]', this.$el);
    this.$showbyTrigger     = $('[data-show-by]', this.$el);
    this.$sortTriggerButton = $('[data-productgrid-trigger-sort-button]', this.$el);
    this.$sortTriggerModal  = $('[data-productgrid-modal-sort]', this.$el);
    this.$filtersTrigger    = $('[data-productgrid-trigger-filters]', this.$el);
    this.$advancedTags      = $('[data-tag-advanced] a', this.$el);
    this.$additionalTags    = $('[data-filter-toggle]', this.$el);
    this.$allTags           = $(`${this.filtersContent} .filter-item a:not([data-filter-toggle])`, this.$el);
    this.$viewToggle        = $('[data-collection-view]', this.$el);
    this.$gridContainer     = $('.productgrid--outer', this.$el);
    this.$gridTagLinks      = $('.filter-item--grid a, .filter-item--grid-simple a', this.$el);
    this.$paginationLinks   = $('a.pagination--item', this.$el);
    this.sidebarContainer  = this.section.el.querySelector('.productgrid--sidebar');
    this.responseContainer = this.section.el.querySelector('.results--container');
    this.clickToLoadTrigger       = this.section.el.querySelector('[data-click-to-load]');
    this.clickToLoad       = this.section.el.querySelector('.click-to-load');
    this.infiniteScrollTrigger    = this.section.el.querySelector('[data-infinite-scroll]');
    this.infiniteScroll    = this.section.el.querySelector('.infinite-scroll');
    this.productGrid = this.responseContainer.querySelector('.productgrid--items');
    this.paginationContainer = this.responseContainer.querySelector('.pagination--container:not(.visually-hidden)');

    this._changeSortingButton = this._changeSortingButton.bind(this);
    this._showSortModal       = this._showSortModal.bind(this);
    this._showFiltersModal    = this._showFiltersModal.bind(this);
    this._activateTag         = this._activateTag.bind(this);
    this._advancedTags        = this._advancedTags.bind(this);
    this._toggleTags          = this._toggleTags.bind(this);
    this._initProductItems    = this._initProductItems.bind(this);
    this._toggleView          = this._toggleView.bind(this);
    this._checkListView       = this._checkListView.bind(this);
    this._formatUrl           = this._formatUrl.bind(this);
    this._initPagination      = this._initPagination.bind(this);

    // Ajax Search functions
    this._updateLinkBindings  = this._updateLinkBindings.bind(this);
    this._updateHistory   = this._updateHistory.bind(this);
    this._bindEvents  = this._bindEvents.bind(this);
    this._ajaxFilter      = this._ajaxFilter.bind(this);
    this._ajaxPagination = this._ajaxPagination.bind(this);
    this._ajaxFetch = this._ajaxFetch.bind(this);
    this._paginationCheck = this._paginationCheck.bind(this);

    this._paginationCheck();

    if (window.history.scrollRestoration && (this.infiniteScroll || this.clickToLoad)) {
      window.history.scrollRestoration = 'manual';
    }

    window.onpopstate = (event) => {
      this._ajaxFilter(event);
    }

    this._bindEvents();

    this._setSortByQueryParameters();
    this._checkListView();

    // Product items
    this.productItems = [];
    this._initProductItems();

    this.modal = new Modal();

    this.recentlyViewed = new RecentlyViewed(section);
  }

  onSectionUnload() {
    this.events.forEach($el => $el.off('.collection'));
    this.ajaxEvents.forEach($el => $el.off('.collection'));

    this.modal.unload();
    this.recentlyViewed.unload();

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });
  }

  _paginationCheck() {
    if (window.location.search.indexOf('page') !== -1) {
      $('.click-to-load, .infinite-scroll').remove();
      this.clickToLoad = null;
      this.infiniteScroll = null;
      this.infiniteScrollTrigger = null;

      $('.pagination--container').removeClass('visually-hidden');
    }
  }

  _initPagination() {
    this._paginationCheck();

    if (this.infiniteScrollTrigger) {
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.intersectionRatio > 0) {
            this._ajaxPagination(true);
          }
        });
      });

      observer.observe(this.infiniteScrollTrigger);
    } else if (this.clickToLoad) {
      this.ajaxEvents.push($(this.clickToLoadTrigger).on('click.collection', () => this._ajaxPagination()));
    } else {
      this.ajaxEvents.push(this.$paginationLinks.on('click.collection', this._ajaxFilter));
    }

    return;
  }

  _initProductItems(productItems = []) {
    let $productItems;

    if (productItems.length == 0) {
      $productItems = $('[data-product-item]', this.$el);
    } else {
      $productItems = $(productItems);
    }

    $productItems = $productItems.filter((i, el) => {
      return el.nodeType != 3;
    });

    $productItems.each((i, productItem) => {
      const productData = JSON.parse(productItem.querySelector('[data-product-data]').innerHTML);

      this.productItems.push(
        new ProductGridItem({
          $el: $(productItem),
          id: this.section.id,
          product: productData,
          queryParams: this.queryString,
        }),
      );

      $(productItem).find('.money').each((index, el) => CurrencyConverter.update(el));
    });
  }

  /**
   * Open Tags/Filters modal (on mobile)
   *
   * @param event
   * @private
   */
  _showFiltersModal(event) {
    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.filtersContent, 'productgrid-filters');
  }

  /**
   * Open Sort by modal (on mobile)
   *
   * @param event
   * @private
   */
  _showSortModal(event) {
    this.$focusItem = $(event.currentTarget);
    this.modal.open(this.sortContent, 'productgrid-sort');
  }

  /**
   * Style a tag as active after click, before page transition
   *
   * @param event
   * @private
   */
  _activateTag(event) {
    if (this.processing) {
      return false;
    }

    $(event.target)
      .closest('.filter-item')
      .toggleClass('filter-item--active')
      .toggleClass('filter-item--inactive');

    this._ajaxFilter(event);
  }

  /**
   * Used by advanced tags to concatenate tag searches
   *
   * @param event
   * @private
   */
  _advancedTags(event) {
    if (this.processing) {
      return false;
    }

    const $target = $(event.currentTarget).parent();
    const tagGroup = $target.attr('data-group');
    const $activeGroup = $(`.filter-item--active[data-group="${tagGroup}"]`);

    if (!$target.hasClass('filter-item--active') && $activeGroup.length) {
      const tagHandle = $target.attr('data-handle');

      event.preventDefault();
      $target.siblings().removeClass('filter-item--active');

      let newLocation = location.href;

      $activeGroup.map((index, activeGroupElement) => $(activeGroupElement).attr('data-handle'))
        .get()
        .forEach((handle, index) => {
          if (index === 0) {
            // swap new tag handle for old one
            newLocation = newLocation.replace(handle, tagHandle);
          } else {
            // remove any other tag handle in the same group
            newLocation = newLocation.replace(new RegExp(`\\+?${handle}`, 'g'), '');
          }
        });

      location.href = newLocation
      // go back to page 1
        .replace(/(&page=\d+)|(page=\d+&)|(\?page=\d+$)/, '');
    }
  }

  /**
   * Expand / Collapse additional tags in the sidebar
   *
   * @param event
   * @private
   */
  _toggleTags(event) {
    event.preventDefault();

    if (this.processing) {
      return;
    }

    const $trigger = $(event.currentTarget);
    const $items = $trigger.parent().siblings('[data-hidden-default]');
    const siblingsVisible = $trigger.data('filter-toggle');

    $items.toggleClass('filter-item--hidden', siblingsVisible);
    $trigger
      .data('filter-toggle', !siblingsVisible)
      .text(!siblingsVisible ? this.context.see_less : this.context.see_more);

    if (this.modal.isOpen()) {
      this.modal.position();
    }
  }

  /**
   * Make Shopify aware of releavent collection search info
   *  - tag
   *  - vendor
   *  - pagination
   *  - sorting criteria
   *
   * @private
   */
  _setSortByQueryParameters() {
    Shopify.queryParams = {};
    if (location.search.length) {
      for (let i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        const aKeyValue = aCouples[i].split('=');
        // Reset the page number when we apply (i.e. don't add it to params)
        if (aKeyValue.length > 1 && aKeyValue[0] !== 'page') {
          this.queryString[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }

      Shopify.queryParams = this.queryString;
    }
  }

  /**
   * Sort by opens a modal on mobile, this handles button events
   *
   * @param event
   * @private
   */
  _changeSortingButton(event) {
    if (this.processing) {
      return false;
    }

    const activeClass = 'utils-sortby--modal-button--active';

    $(event.currentTarget)
      .addClass(activeClass)
      .parent()
      .siblings()
      .find(`.${activeClass}`)
      .removeClass(activeClass);

    this._ajaxFilter(event);
  }

  /**
   * Toggle grid or list view
   *
   */
  _toggleView(event) {
    const view = event.currentTarget.getAttribute('data-collection-view');
    this.queryString.grid_list = view;
    Shopify.queryParams.grid_list = view;

    const toggleUrl = this._formatUrl(location.pathname);

    this._updateHistory(toggleUrl);
    this._checkListView();

    this.productItems.forEach((productItem) => {
      productItem.unload();
    });

    this.productItems = [];

    this._initProductItems();
  }

  /**
   * Check grid/list view toggle query parameters
   *
   */
  _checkListView() {
    const view = this.queryString.grid_list ? this.queryString.grid_list : 'grid-view';

    this.$el.find('.utils-viewtoggle-button').removeClass('active');
    $(`[data-collection-view=${view}]`).addClass('active');

    const className = view.replace('-', '');

    if (className === "listview") {
      this.$gridContainer.removeClass('productgrid-gridview');
    } else {
      this.$gridContainer.removeClass('productgrid-listview');
    }

    this.$gridContainer.addClass(`productgrid-${className}`);

  }

  /**** AJAX search functions ****/

  /**
   * Format URL using this.queryString to append parameters (page/sort_by/show_by etc.)
   */
  _formatUrl(href, updateHistory = false) {
    let newHref;
    let replaceIndex;
    let firstHalf;

    this._paginationCheck();

    if (href.indexOf('?') >= 0) {
      // Find the start of the querystring and split the URL
      const replaceIndex = href.indexOf('?');
      firstHalf = href.substr(0, replaceIndex);
    } else {
      firstHalf = href;
    }

    let secondHalf = [];

    for (const param in this.queryString) {
      if (this.queryString[param] == '_ajax-collection'
        || (param == 'view' && !updateHistory)
        || (param == 'page' && updateHistory && (this.infiniteScroll || this.clickToLoad))
      ) {
        continue;
      }

      secondHalf.push(`${param}=${this.queryString[param]}`);
    }

    if (secondHalf.length > 0) {
      secondHalf = secondHalf.join('&');
      newHref = firstHalf.concat('?', secondHalf);
    } else {
      newHref = firstHalf;
    }

    return newHref;
  }

  _setProcessing(processing = true, type = 'filter') {
    this.processing = processing;

    const processingType = type == 'popstate' ? 'filter' : type;

    if (processing) {
      if (this.sidebarContainer) {
        this.sidebarContainer.classList.add(`processing--${processingType}`);
      }
      this.responseContainer.classList.add(`processing--${processingType}`);
    } else {
      if (this.sidebarContainer) {
        this.sidebarContainer.classList.add(`processing--${processingType}`);
      }
      this.responseContainer.classList.remove(`processing--${processingType}`);
    }
  }

  /**
   * Retrieve the template containing filtered product items and tags via AJAX
   */
  _ajaxFilter(event) {
    event.preventDefault();
    event.stopPropagation();

    if (this.processing == true) {
      return;
    }

    const target = event.currentTarget;
    let fetchUrl = location.pathname;
    let type = 'filter';

    if (event.type == 'popstate') {
      if (event.state === null) {
        return;
      }
      this.queryString = {};
      this._setSortByQueryParameters();
      fetchUrl = event.state.path;
      type = 'popstate';
    } else {
      this.queryString.page = 1;
      if (target.hasAttribute('data-show-by')) { // 'Show by' - number of products per page
        this.queryString.view = target.getAttribute('data-show-by');
      } else if (target.hasAttribute('data-productgrid-trigger-sort') || target.hasAttribute('data-productgrid-trigger-sort-button')) { // Sortby select/button
        this.queryString.sort_by = $(target).val();
      } else if (target.hasAttribute('data-to-page')) { // Pagination link
        this.queryString.page = target.getAttribute('data-to-page');
      } else { // Filter links
        fetchUrl = target.getAttribute('href');
      }
    }

    this._ajaxFetch(fetchUrl, type);
  }

  _ajaxPagination(infiniteScroll = false) {
    const baseUrl = location.pathname;
    const view = this.queryString.view ? `_ajax-collection-${this.queryString.view}` : '_ajax-collection';
    let toPage;

    if (infiniteScroll) {
      toPage = this.infiniteScrollTrigger.getAttribute('data-to-page');
    } else {
      toPage = this.clickToLoadTrigger.getAttribute('data-to-page');
    }

    if (toPage) {
      this.queryString.page = toPage;
    }

    this._ajaxFetch(baseUrl, 'pagination');
  }

  _ajaxFetch(url, type) {
    const view = this.queryString.view ? `_ajax-collection-${this.queryString.view}` : '_ajax-collection';
    // Trigger UI processing state
    this._setProcessing(true, type);
    if (type == 'filter') {
      let y = $(window).scrollTop();
      if (y >= 310){
        $('html, body')
          .animate({scrollTop: y-300}, 150)
          .animate({scrollTop: 10}, 0)
          .animate({scrollTop: 0}, 150);
      } else {
        $('html, body').animate({scrollTop: 0}, 150);
      }
    }

    const fetchUrl = this._formatUrl(url);

    AsyncView.load(fetchUrl, view)
      .done(({ html, options }) => {

        if (type == 'pagination') {
          const $productItems = $(html.productgridItems);

          if ($productItems.length > 0) {
            $productItems.each((i, item) => {
              $(this.productGrid).append(item);
            });

            this.paginationContainer.innerHTML = html.pagination;

            this._initProductItems($productItems);
          }

        } else {
          this.responseContainer.innerHTML = html.productgrid;
          if (this.sidebarContainer) {
            this.sidebarContainer.innerHTML = html.sidebar;
          }

          this.productItems.forEach((productItem) => {
            productItem.unload();
          });

          this.productItems = [];

          this._initProductItems();
        }

        rimg.watch(this.responseContainer);

        if (this.modal.isOpen()) {
          this.modal.close();
        }

        // Update link bindings with new DOM elements
        this._updateLinkBindings();

        if (type != 'popstate') {
          // Push the current location state to the browser history if not accessed via the back button
          this._updateHistory(fetchUrl);
        }


        // Once it's all updated, update the UI to show processing is complete
        this._setProcessing(false, type);
      });
  }


  /**
   * Unbind AJAX events for links no longer on the page, and bind new links
   */
  _updateLinkBindings() {
    this.ajaxEvents.forEach($el => $el.off('.collection'));

    this.$viewToggle.off('.collection');
    this.$filtersTrigger.off('.collection');
    this.$sortTriggerModal.off('.collection');
    this.$allTags.off('.collection'),
    this.$additionalTags.off('.collection');

    this.$gridTagLinks      = $('.filter-item--grid a, .filter-item--grid-simple a', this.$el);
    this.$additionalTags    = $('[data-filter-toggle]', this.$el);
    this.$viewToggle        = $('[data-collection-view]', this.$el);
    this.$filtersTrigger    = $('[data-productgrid-trigger-filters]', this.$el);
    this.$sortTriggerModal  = $('[data-productgrid-modal-sort]', this.$el);
    this.$sortTrigger       = $('[data-productgrid-trigger-sort]', this.$el);
    this.$showbyTrigger     = $('[data-show-by]', this.$el);
    this.$paginationLinks   = $('a.pagination--item', this.$el);
    this.$allTags           = $(`${this.filtersContent} .filter-item a:not([data-filter-toggle])`, this.$el);
    this.clickToLoad       = this.section.el.querySelector('.click-to-load');
    this.clickToLoadTrigger       = this.section.el.querySelector('[data-click-to-load]');
    this.infiniteScrollTrigger    = this.section.el.querySelector('[data-infinite-scroll]');
    this.infiniteScroll    = this.section.el.querySelector('.infinite-scroll');
    this.productGrid = this.responseContainer.querySelector('.productgrid--items');
    this.paginationContainer = this.responseContainer.querySelector('.pagination--container:not(.visually-hidden)');

    this._bindEvents();
  }

  /**
   * Bind filter link click events to new ajax functionality
   */
  _bindEvents() {
    const links = this.$gridTagLinks.get()
      .concat(this.$showbyTrigger.get());

    links.forEach((el) => {
      this.ajaxEvents.push(
        $(el).on('click.collection', this._ajaxFilter),
      );
    });

    this.ajaxEvents.push(this.$sortTrigger.on('change.collection', this._ajaxFilter));

    this.events.push(
      this.$viewToggle.on('click.collection', this._toggleView),
      this.$filtersTrigger.on('click.collection', this._showFiltersModal),
      this.$allTags.on('click.collection', this._activateTag),
      this.$additionalTags.on('click.collection', this._toggleTags),
      this.$sortTriggerModal.on('click.collection', this._showSortModal)
    );

    this._initPagination();
  }

  /**
   * Update the page URL so users can link to their particular search
   */
  _updateHistory(path) {
    if ((window.Shopify && window.Shopify.designMode) || !history.pushState) {
      return;
    }

    const newPath = this._formatUrl(path, true);

    let newUrl = [
      window.location.protocol,
      '//',
      window.location.host,
      newPath,
    ];

    newUrl = newUrl.join('');

    if (window.location.href != newUrl) {
      window.history.pushState({ path: newPath }, '', newUrl);
    }

    this._setSortByQueryParameters();
  }
}
